import { Button, Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import admissionFeeDetailService from "../../../services/admissionFeeDetailService";
import logger from "../../../services/logger";
import Add from "../../common/add";
import ButtonLink from "../../common/buttonLink";
import PagingAndSorting from "../../common/pagingAndSorting";
import FeeDetailTable from "./feeDetailTable";

class FeeDetails extends PagingAndSorting {
  state = {
    data: [],
    sortColumn: { path: "id", order: "asc" },
    page: 0,
    rowsPerPage: 10,
    confirmDialogOpen: false,
  };

  getAll = async () => {
    try {
      const { data } = await admissionFeeDetailService.getAll();
      this.setState({ data });
    } catch (ex) {
      logger.error(ex);
    }
  };

  onConfirmOk = async (id) => {
    try {
      await admissionFeeDetailService.deleteById(id);
      await this.getAll();
    } catch (ex) {
      logger.error(ex);
    }
  };

  componentDidMount() {
    this.getAll();
  }

  render() {
    const { sortColumn, data } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Grid container>
          <Grid container item sm={12} md={12} lg={12} direction="row-reverse">
            {/* <Button variant="contained" color="secondary">
              <Link to={"admission-fee-details/new"}>{t("New Config")}</Link>
            </Button> */}

          <Add link={"admission-fee-details/new/new"} title={t("New Fee Details")} />
          </Grid>
<br />
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FeeDetailTable
              data={data}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              onDelete={this.handleDelete}
            />
          </Grid>
        </Grid>
        {this.renderDeleteConfirmDialog(
          "Delete Confirmation",
          "Are you sure you want to delete?"
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation(["feeDetail","common"])(
  FeeDetails
);
